/* eslint-disable react/no-array-index-key */
import type { ComponentProps } from 'react';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import type { OAISchema } from '~/types/openapi';

import ECouponProductCard from '../ECouponProductCard';
import ProductCard from '../ProductCard';

type Props = {
  data: OAISchema['MarketSelectProductResponseV2'][];
  fetchNextPage: () => void;
  hasNextPage: boolean | undefined;
} & Pick<
  ComponentProps<typeof ProductCard>,
  'reverseCouponDiscountedPrice' | 'onCartClick' | 'onClick'
>;

const InfiniteProductGridDisplay = ({
  data = [],
  onClick,
  onCartClick,
  reverseCouponDiscountedPrice,
  ...props
}: Props) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      if (props.hasNextPage) props.fetchNextPage();
    }
  }, [inView, props]);

  return (
    <section className="grid grid-cols-2 gap-x-16 gap-y-24">
      {data.map((item, index) => {
        if (item.productType === PRODUCT_TYPE_E_COUPON) {
          return (
            <ECouponProductCard
              key={item.offerId}
              {...item}
              onClick={onClick}
              reverseCouponDiscountedPrice={reverseCouponDiscountedPrice}
              eventOption={{
                // item이 몇번쨰 노출되는지 이벤트 프로퍼티 전송
                rank: index + 1,
              }}
            />
          );
        }

        return (
          <ProductCard
            key={item.offerId}
            {...item}
            onClick={onClick}
            onCartClick={onCartClick}
            plusMembershipFullBadge
            reverseCouponDiscountedPrice={reverseCouponDiscountedPrice}
            eventOption={{
              // item이 몇번쨰 노출되는지 이벤트 프로퍼티 전송
              rank: index + 1,
            }}
          />
        );
      })}
      <div ref={ref} className="h-24" />
    </section>
  );
};

export default InfiniteProductGridDisplay;
